import { AppState } from '../../reducers';
import { createSelector } from 'reselect';

const selectPanier = (state: AppState) => state.panier;

export const getPanier = createSelector(selectPanier, panier => panier);

export const getPanierProductsCount = createSelector(
  selectPanier,
  panier => panier.commandeLines?.length || 0
);
